import { render, staticRenderFns } from "./ExportDeleteModal.vue?vue&type=template&id=706b4201&"
import script from "./ExportDeleteModal.vue?vue&type=script&lang=js&"
export * from "./ExportDeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports